export const LOAD_POST = 'LOAD_POST'
export const ADD_POST = 'ADD_POST'


